import api from './api';

// Corvin's tips. GET answers 204 when there is nothing to say; that is null
// here, never an error.
const corvinAPI = {
  getTip: () => api.get('/corvin/tip').then((r) => (r.status === 204 || !r.data ? null : r.data)),
  dismiss: (key) => api.post(`/corvin/tips/${encodeURIComponent(key)}/dismiss`),
};

export default corvinAPI;
